import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NotificationImageContent, NotificationTemplate } from "src/app/core/models/notification.model";
import { NavigationService } from "src/app/core/core-services/services/navigation.service";
import { NotificationTemplateRenderer } from "../notification-template-renderer";

/** Renders `{kind: "image", content: {title?, body?, image_url, alt?, url?}}`. The image opens `url` (if present) via `NavigationService`. */
@Component({
  selector: "app-notification-image-renderer",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./notification-image-renderer.component.html",
  styleUrls: ["../notification-templates.scss"],
})
export class NotificationImageRendererComponent implements NotificationTemplateRenderer {
  @Input() template!: NotificationTemplate;
  @Output() respond = new EventEmitter<Record<string, unknown>>();

  constructor(private readonly navigationService: NavigationService) {}

  private get content(): NotificationImageContent {
    return this.template?.content as unknown as NotificationImageContent;
  }

  get title(): string | undefined {
    return this.content?.title;
  }

  get body(): string | undefined {
    return this.content?.body;
  }

  get imageUrl(): string {
    return this.content?.image_url ?? "";
  }

  get alt(): string {
    return this.content?.alt || this.content?.title || "";
  }

  get isClickable(): boolean {
    return !!this.content?.url;
  }

  open(): void {
    if (this.content?.url) {
      this.navigationService.navigateToUrl(this.content.url);
    }
  }
}
